import { render, staticRenderFns } from "./QuestionContainer.vue?vue&type=template&id=5dd26bbe&"
import script from "./QuestionContainer.vue?vue&type=script&lang=js&"
export * from "./QuestionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports